import I18n from 'I18n';
// TODO: Handle errors, like network errors, etc.
export const getVariantName = asset => asset !== null && asset !== void 0 && asset.status ? I18n.text(`personalizationLib.variantSelect.options.${asset.status}`, {
  name: asset.name
}) : asset === null || asset === void 0 ? void 0 : asset.name;